import { type Dispatch } from "@reduxjs/toolkit";
import { tagEntity } from "components/addTagsModal/helpers";
import { type AppDispatch, type AppThunk } from "features/Application/globaltypes/redux";
import DataService from "features/Application/services/dataServices/typedDataService";
import backgroundTask from "features/BackgroundTasks/backgroundTask";
import { type MessageIdsType, type UpdateParams } from "interfaces";
import { type TagsEnum } from "interfaces/TagsEnum";
import { pluralize } from "utils/stringUtils";
import { fetchTags, fetchTagsFailure } from "../slices/TagsSlice";

export const fetchTagsAction = () => async (dispatch: Dispatch) => {
  try {
    const res = await DataService.scorm.getTagsFilterOptions(true);
    dispatch(fetchTags(res.data));
  } catch (e) {
    dispatch(fetchTagsFailure(e as Error));
  }
};

export const addTagsAction =
  (ids: number[], tags: string[], tagType: TagsEnum): AppThunk =>
  async (dispatch: AppDispatch) => {
    if (!tags.length) {
      return;
    }

    const getMessageIds = () => async (): Promise<MessageIdsType> => {
      const result = await DataService.scorm.addTags({ ids, tags, tagType });
      return result?.data.messageIds;
    };

    const transientMessagePrefix = pluralize(tagEntity[tagType], tags.length);

    const updateParams: UpdateParams = {
      id: "AddTagsToSCORM",
      title: `${transientMessagePrefix} adding`,
      getMessageIds: getMessageIds(),
      successTransientMessage: `${transientMessagePrefix} ${tags.length === 1 ? "has" : "have"} been added!`,
      failureTransientMessage: `${transientMessagePrefix} add failed!`,
    };

    await backgroundTask.initializeBackgroundTask(updateParams, dispatch);
  };
